import React from 'react';
import { useTranslation } from 'react-i18next';
import { Routes } from 'router/routes';
import NavigationHeader from 'components/molecules/navigation-header';
import ExpandableSmsMetricsFilters from 'components/organisms/sms-metrics/expandable-filters';
import { useSmsMetricsQueryFilterNew } from 'infrastructure/hooks/sms-metrics/use-query-filter';
import BaseGrid from 'components/atoms/base-grid';
import AutomatedVsHandledMessagesChart from 'components/molecules/sms-metrics/automated-vs-handled-messages-chart';
import SmsStatusOverviewPieChart from 'components/molecules/sms-metrics/status-overview-pie-chart';
import SmsTypeOverviewPieChart from 'components/molecules/sms-metrics/type-overview-pie-chart';

import s from './styles.module.scss';

const SmsDashboardMetricsPage: React.FC = () => {
  const { t } = useTranslation();

  const { filter, updateFilter, resetFilter, count } =
    useSmsMetricsQueryFilterNew();

  return (
    <div>
      <NavigationHeader
        goBackPath={Routes.dashboard}
        title={t('links.smsDashboardMetrics')}
      />
      <BaseGrid rowGap={64}>
        <ExpandableSmsMetricsFilters
          data={filter}
          updateFilter={updateFilter}
          resetFilter={resetFilter}
          count={count}
        />

        <div className={s.pies}>
          <SmsStatusOverviewPieChart filter={filter} />
          <SmsTypeOverviewPieChart filter={filter} />
        </div>
        <AutomatedVsHandledMessagesChart filter={filter} />
      </BaseGrid>
    </div>
  );
};

export default SmsDashboardMetricsPage;
